<template>
  <div class="pagination">
    <button
        @click="$emit('change-page', currentPage - 1)"
        :disabled="currentPage <= 1"
        class="btn-page"
    >
      قبلی
    </button>

    <span class="page-info">
      صفحه {{ currentPage }} از {{ totalPages }}
    </span>

    <button
        @click="$emit('change-page', currentPage + 1)"
        :disabled="currentPage >= totalPages"
        class="btn-page"
    >
      بعدی
    </button>

    <span class="total-info">
      مجموع: {{ total }} رکورد
    </span>
  </div>
</template>

<script>
export default {
  name: 'Pagination',

  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  padding: 10px 0;
}

.btn-page {
  padding: 6px 16px;
  background: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn-page:hover:not(:disabled) {
  background: #66b1ff;
}

.btn-page:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #606266;
}

.total-info {
  font-size: 14px;
  color: #909399;
  margin-left: 10px;
}
</style>